import './_sidebar.scss'
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

export default function SocialMedia({ justifyContent }) {
    return (
        <div className={`d-flex justify-content-${justifyContent} social-media-icons`}>
            <a href='#'><FacebookOutlinedIcon fontSize='small' /></a>
            <a href='#'><InstagramIcon fontSize='small' /></a>
            <a href='#'><LinkedInIcon fontSize='small' /></a>
            <a href='#'><GitHubIcon fontSize='small' /></a>
        </div>
    )
}
